import type { Project, Src, Dst } from "..";

export type GetIFDefinitionHistoryResponse = {
  /**
   * The results of this get_if_definition_history response body.
   */
  total: number;
  ifList: GetIfHistoryList[];
};
export type GetIfHistoryList = {
  srcDplymntReqSeqNum: string;
  srcDplymntDtime: string;
  dstDplymntReqSeqNum: string;
  dstDplymntDtime: string;
  project: Project;
  src: Src;
  dst: Dst;
};
